<template>
  <v-container fluid>

  <v-card class="mx-auto">
    <v-card-title>
        Crawl Documents
    </v-card-title>

    <v-card-text>
        <v-btn :disabled="isAppLoading" @click="loadExams">
          Load Exams from S3
        </v-btn>
    </v-card-text>
  </v-card>
  <div>
    {{result}}
  </div>
  </v-container>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      result: null
    };
  },
  computed: {
    ...mapGetters(["isAppLoading"])
  },
  methods: {
    loadExams(){
      this.$axios.get('/s3/recordExamFromS3', {params: {path: 'assets/pdfs/raw/'}})
        .then( resp => {
          this.result = resp.data;
        })
    }
  }
};
</script>

<style>
</style>